var _rect, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 40,
    height: 40,
    fill: "#CD63FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 30.4998L11.425 26.0665C9.95227 23.9759 9.29311 21.4197 9.57122 18.8776C9.84933 16.3355 11.0456 13.9823 12.9355 12.2596C14.8254 10.5369 17.279 9.56309 19.8359 9.52096C22.3928 9.47882 24.8772 10.3713 26.8229 12.0308C28.7685 13.6903 30.0417 16.0028 30.4034 18.5344C30.7651 21.0659 30.1905 23.6424 28.7875 25.7804C27.3844 27.9184 25.2493 29.4709 22.783 30.1465C20.3166 30.8221 17.6884 30.5744 15.3917 29.4498L9.5 30.4998",
    stroke: "#CD63FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 17.666C16.5 17.8207 16.5615 17.9691 16.6709 18.0785C16.7803 18.1879 16.9286 18.2493 17.0833 18.2493C17.238 18.2493 17.3864 18.1879 17.4958 18.0785C17.6052 17.9691 17.6667 17.8207 17.6667 17.666V16.4993C17.6667 16.3446 17.6052 16.1963 17.4958 16.0869C17.3864 15.9775 17.238 15.916 17.0833 15.916C16.9286 15.916 16.7803 15.9775 16.6709 16.0869C16.5615 16.1963 16.5 16.3446 16.5 16.4993V17.666ZM16.5 17.666C16.5 19.2131 17.1146 20.6968 18.2085 21.7908C19.3025 22.8848 20.7862 23.4993 22.3333 23.4993H23.5C23.6547 23.4993 23.8031 23.4379 23.9125 23.3285C24.0219 23.2191 24.0833 23.0707 24.0833 22.916C24.0833 22.7613 24.0219 22.6129 23.9125 22.5035C23.8031 22.3941 23.6547 22.3327 23.5 22.3327H22.3333C22.1786 22.3327 22.0302 22.3941 21.9209 22.5035C21.8115 22.6129 21.75 22.7613 21.75 22.916C21.75 23.0707 21.8115 23.2191 21.9209 23.3285C22.0302 23.4379 22.1786 23.4993 22.3333 23.4993",
    stroke: "#CD63FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.cfbd001a.svg";
export { ForwardRef as ReactComponent };